import { Directive, OnInit } from '@angular/core';
import { map, Observable } from 'rxjs';

import { UaService } from '@ecm/consumer';
import { EnvUtils } from '@ecm/dispatcher';
import { RouterService } from '@ecm/router';

@Directive()
export abstract class AbstractComponent implements OnInit {
    public isMobile: boolean;
    public isEclair: boolean;

    protected constructor(
        protected uaService: UaService,
        protected routerService: RouterService,
    ) {}

    /**
     * Gets current contract Id from URL
     * Subscribes onContractOpened event
     */
    public ngOnInit(): void {
        this.isEclair = EnvUtils.isEclair();

        this.isMobile = this.uaService.isMobile();
    }

    /**
     * Asks router service from ecm-router if context is Sosh
     */
    public isSoshBrand(): Observable<boolean> {
        return this.routerService.isCurrentRouteSosh().pipe(
            map((isSosh: boolean) => {
                return isSosh;
            }),
        );
    }
}
